import { PATH_NAME } from 'configs/pathName';
import { useGlobalContext } from 'context/GlobalContext';
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

function FoundNameGuard() {
  const { user } = useGlobalContext();
  const username = user.username;

  if (!username) return <Navigate to={PATH_NAME.LOGIN} />;

  return <Outlet />;
}

export default FoundNameGuard;